<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">基金组合记录</span>
      <Reback class="row-one-fr" @click.native="returnOne"></Reback>
      <span class="row-one-fr" @click="detailsClick">查看资产详情</span>
    </el-row>
    <!-- 主页 -->
    <div v-show="stepDisplay == '1'">
      <el-form :model="searchForm" class="form-single-inline margin-t20">
        <el-form-item label="起止日期：">
          <el-radio-group v-model="searchForm.datetype" class="radio-single-btn1" @change="dateChange">
            <el-radio-button v-for="(item,i) in setTimeData" :label="item.time" :key="i+'dt'">{{item.name}}</el-radio-button>
          </el-radio-group>
          <!-- <el-date-picker v-model="searchForm.dateRange" unlink-panels type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker> -->
          <el-date-picker v-model="searchForm.datevalue1" type="date" placeholder="选择日期" @change="dateOneChange">
          </el-date-picker>
          至
          <el-date-picker v-model="searchForm.datevalue2" type="date" placeholder="选择日期" @change="dateTwoChange">
          </el-date-picker>
          <el-button type="search" class="margin-l10" @click="searchClick">查询 <i class="el-icon-search"></i></el-button>
        </el-form-item>
        <!-- 交易状态 -->
        <el-form-item label="交易状态：">
          <el-radio-group v-model="searchForm.state" class="radio-single-btn1" @change="stateChange">
            <el-radio-button v-for="(item,i) in tradeStateData" :label="item.value" :key="i+'lx'">{{item.name}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- 交易类型 -->
        <el-form-item label="交易类型：">
          <el-radio-group v-model="searchForm.type" class="radio-single-btn1" @change="typeChange">
            <el-radio-button v-for="(item,i) in tradeTypeData" :label="item.value" :key="i+'lx'">{{item.name}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table :data="tradeTableData" class="table-single margin-t20" stripe v-loading="loading" element-loading-text="加载中...">
        <el-table-column prop="applyDate" label="申请时间"></el-table-column>
        <el-table-column prop="status" label="交易类型"></el-table-column>
        <el-table-column prop="fundName" label="组合名称"></el-table-column>
        <el-table-column prop="investamount" label="金额（元）"></el-table-column>
        <el-table-column prop="account" label="关联账户" width="185"></el-table-column>
        <el-table-column prop="orderstatus" label="交易状态"></el-table-column>
        <el-table-column prop="details" label="详情">
          <template slot-scope="scope">
            <span class="table-single-btn-normal" @click="recordDetailClick(scope.row)">详情</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 页码 -->
      <el-pagination class="pagination-single" @current-change="handleCurrentChangeOne" :current-page.sync="trade.Page" :page-size="trade.PageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      stepDisplay: '1',
      searchForm: {
        datetype: this.$commonJs.getBeforeDate(7, 'd7', '/'),
        type: '',
        state: '',
        datevalue1: this.$commonJs.getBeforeDate(7, 'd7', '/'),
        datevalue2: this.$commonJs.getBeforeDate(0, 'd7', '/'),

      },
      tradeTableData: [],
      trade: {
        Page: 1,
        PageNum: 20
      },
      total: 0,
      // 时间多选
      setTimeData: [
        {
          name: '全部',
          value: 'all',
          time: ''
        },
        {
          name: '近一周',
          value: 'oneWeek',
          time: this.$commonJs.getBeforeDate(7, 'd7', '/')
        },
        {
          name: '近一月',
          value: 'oneMonth',

          time: this.$commonJs.getBeforeDate(0, 1, '/')
        },
        {
          name: '近三月',
          value: 'threeMonth',

          time: this.$commonJs.getBeforeDate(0, 3, '/')
        },
        {
          name: '近半年',
          value: 'halfYear',

          time: this.$commonJs.getBeforeDate(0, 6, '/')
        },
        {
          name: '近一年',
          clickName: 'oneYear',

          time: this.$commonJs.getBeforeDate(0, 12, '/')
        }
      ],
      tradeStateData: [
        {
          name: '不限',
          value: '',
          isActive: true
        },
        {
          name: '确认中',
          value: '3',
          isActive: false
        },
        {
          name: '成功',
          value: '1',
          isActive: false
        },
        {
          name: '支付失败',
          value: '4',
          isActive: false
        },
        {
          name: '赎回失败',
          value: '0',
          isActive: false
        },
        {
          name: '已撤单',
          value: '2',
          isActive: false
        },
      ],
      tradeTypeData: [
        {
          name: '不限',
          value: '',
          isActive: true
        },
        {
          name: '买入',
          value: '02',
          isActive: false
        },
        {
          name: '卖出',
          value: '04',
          isActive: false
        },
      ],
    }
  },
  mounted () {
    this.getCombinationRecordList()
  },
  methods: {
    // 选项时间
    dateChange (val) {
      this.searchForm.datevalue1 = val
      this.searchForm.datevalue2 = this.$commonJs.getBeforeDate(0, 'd7', '/')
    },
    // 开始日期
    dateOneChange (val) {
      this.searchForm.datetype = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '')
      this.searchForm.datevalue1 = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '/')
    },
    // 结束日期
    dateTwoChange (val) {
      // this.searchForm.datetype = '1'
      // this.searchForm.datevalue1 = this.$commonJs.getBeforeDate(0, 36, '')
      this.searchForm.datevalue2 = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '/')
    },
    // 查询
    searchClick () {
      this.loading = true
      this.trade.Page = 1
      this.getCombinationRecordList()
    },
    // 状态改变
    stateChange (val) {
      // this.loading = true
      this.searchForm.state = val
      // this.getCombinationRecordList()
    },
    // 类型改变
    typeChange (val) {
      // this.loading = true
      this.searchForm.type = val
      // this.getCombinationRecordList()
    },
    returnOne () {
      this.$router.push({
        name: 'myAssets'
      })

    },
    detailsClick () {
      this.$router.push({
        name: 'combinationAssetsMessage',
        params: {
          value: 'combinationRecord'
        },
      })
    },

    handleCurrentChangeOne (newPage) {
      this.loading = true
      this.trade.Page = newPage
      this.getCombinationRecordList()
    },
    // 获取组合列表
    getCombinationRecordList () {
      let begin = ''
      if (this.searchForm.datetype == '') {
        begin = this.$commonJs.getBeforeDate(0, 36, '')
      } else {
        begin = this.searchForm.datevalue1.replace('/', '').replace('/', '')
      }
      this.$http.post(this.$apiPath.pcGroupRecord, {
        custno: this.$commonJs.getCookie('u_custno1'),
        businesscode: '',
        combinationcode: '',
        fundcode: '',
        // sessionId: this.$commonJs.getCookie('sessionid'),
        paycenterid: "",
        begindate: begin,
        enddate: this.searchForm.datevalue2.replace('/', '').replace('/', ''),//this.searchForm.datevalue2.replace('/', '').replace('/', '')
        requestid: this.trade.Page,//页数
        transcode: this.searchForm.state,//交易状态
        status: this.searchForm.type//交易类型
      }).then(res => {
        // console.log(res);
        this.loading = false
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result.funds.length > 0) {
          // console.log(result);
          result.funds.forEach(item => {
            if (item.status == "02") {
              item.status = '买入'
            } else if (item.status == "04") {
              item.status = '卖出'
            }
            item.combinationcode ? item.fundName = this.$commonJs.getCombinationNameByCode(item.combinationcode) : '--'
            item.applyDate = this.$commonJs.getDateStrTh(item.operdate) + ' ' + item.opertime
            item.investamount ? item.investamount = item.investamount : '--'
            item.reducedMoney = item.investamount - item.moneyasset
            // 关联账户
            item.account = ''
            if (item.businesskind == "0") {
              if (item.channelid) {
                item.account += this.$commonJs.getBankInfo(item.channelid)
              }
              if (item.depositacct) {
                item.account += "(**" + (item.depositacct).substring((item.depositacct).length - 4) + ")"
              }
              if (item.investamount && item.moneyasset) {
                if (parseFloat(item.reducedMoney) > 200) {//判断基金立减抵扣券金额大于200
                  item.moneyasset = '0.00'
                  item.reducedMoney = '0.00'
                }
                if (parseFloat(item.reducedMoney) > 0) {
                  item.account += "+优惠券"
                }
              }
            } else {
              item.account += "恒宝宝";
            }
            // 交易状态
            // item.orderstatus = '--'
            if (item.orderstatus == "0") {
              item.orderstatus = '赎回失败'
            } else if (item.orderstatus == "1") {
              item.orderstatus = '确认成功'
            } else if (item.orderstatus == "2") {
              item.orderstatus = '已撤单'
            } else if (item.orderstatus == "3") {
              item.orderstatus = '确认中'
            } else if (item.orderstatus == "4") {
              item.orderstatus = '支付失败'
            }


          });
          this.tradeTableData = result.funds
          this.total = result.totalNum
        } else {
          this.tradeTableData = []
          this.total = 0
        }
      })
    },
    recordDetailClick (row) {
      this.$router.push({
        name: 'combinationRecordDetail',
        params: {
          message: row
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>